// Downloads the "Listing Score" Excel workbook from the backend.
// Server-side generation is the single source of truth for the two-header /
// Summary / per-image format (see backend app/listing_score/excel_export.py).
//
//   downloadListingScoreExcel({ token, taskId })  → bulk run (data + Summary)
//   downloadListingScoreExcel({ token, asin })    → single listing (data only)
import { saveAs } from 'file-saver';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export async function downloadListingScoreExcel({ token, taskId, asin }) {
    if (!token) throw new Error('Please log in to download.');

    const params = new URLSearchParams();
    if (taskId) params.set('task_id', taskId);
    else if (asin) params.set('asin', asin);

    const response = await fetch(
        `${API_URL}/listing_score/download-excel?${params.toString()}`,
        { method: 'GET', headers: { Authorization: `Bearer ${token}` } }
    );

    if (!response.ok) {
        let message = `Download failed (${response.status})`;
        try {
            const data = await response.json();
            if (data && data.error) message = data.error;
        } catch (_) { /* non-JSON error body */ }
        throw new Error(message);
    }

    // Prefer the backend-provided filename (Content-Disposition); fall back locally.
    const disposition = response.headers.get('Content-Disposition') || '';
    const match = disposition.match(/filename="?([^"]+)"?/);
    const fallback = taskId ? 'ListingScore_Bulk.xlsx' : `ListingScore_${asin || 'export'}.xlsx`;
    const filename = match ? match[1] : fallback;

    const blob = await response.blob();
    saveAs(new Blob([blob], { type: XLSX_MIME }), filename);
}
